// Need to use the React-specific entry point to import createApi
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

import { getAuthorizationHeaders } from "services/api";
import { WHOLSTER_REST_BASE_URL } from "services/config";

// Define a service using a base URL and expected endpoints
export const wholsterApi = createApi({
  reducerPath: "wholsterApi",
  baseQuery: fetchBaseQuery({
    baseUrl: `${WHOLSTER_REST_BASE_URL}/`,
    prepareHeaders: (headers, { getState }) => {
      const authorizationHeaders = getAuthorizationHeaders(getState().login.sessionId);
      Object.entries(authorizationHeaders).forEach(([name, value]) => headers.set(name, value));
      return headers;
    },
  }),
  endpoints: (builder) => ({
    getListingById: builder.query({
      query: (id) => `listing/${id}`,
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetListingByIdQuery } = wholsterApi;
